// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  GRANT_TYPE_LOGIN: process.env.REACT_APP_GRANT_TYPE_LOGIN,
  GRANT_TYPE_REFRESH: process.env.REACT_APP_GRANT_TYPE_REFRESH,
  AUTHEN_PORT: process.env.REACT_APP_AUTHEN_PORT,
  BUSINESS_PARTNER_MANAGER_PORT: process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT,
  COM_CODE: process.env.REACT_APP_COM_CODE,
  PREFIX_USERNAME: process.env.REACT_APP_USERNAME,
  RESOURCE_MANAGER_PORT: process.env.REACT_APP_RESOURCE_MANAGER_PORT
};
